/**
 * Frontend configuration
 * Centralizes environment variables and default values
 *
 * Environment-specific values are set in:
 * - .env (local development)
 * - .env.test (test environment)
 * - .env.production (production environment)
 */

// Helper to get API URL with production validation
const getApiUrl = (): string => {
  const url = import.meta.env.VITE_API_URL;
  if (!url && import.meta.env.PROD) {
    throw new Error('VITE_API_URL must be configured in production');
  }
  return url || 'http://localhost:8000/api/v1';
};

export const config = {
  // API URLs
  API_URL: getApiUrl(),
  LEGACY_CMS_URL: import.meta.env.VITE_LEGACY_CMS_URL || 'https://cloud.gwii.net/cgi-bin/testcms',
  // Base URL of the v2 CMS app (the "cms.gwii.net" React site we deep-link into)
  V2_URL: import.meta.env.VITE_V2_URL || 'https://cms.gwii.net',

  // Google Maps
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
} as const;
